var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v("Delete Cron Job")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12"
                    }
                  },
                  [
                    _c("p", [
                      _vm._v("Are you sure you wish to "),
                      _c("strong", [_vm._v("permanently")]),
                      _vm._v(" remove this cron job?")
                    ])
                  ]
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.loading
                },
                on: {
                  click: _vm.deleteJob
                }
              },
              [_vm._v("Delete")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }